import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSidebarData } from "../../shared/api/sidebarService";
import { ICompanyUpdateResource } from "../../shared/types";
import { ViewPageSectionListItemWrapper } from "../../shared/view";

interface Props {
	company: ICompanyUpdateResource;
}

export const CompanyViewTenantPivotSection: FC<Props> = ({ company }) => {
	const { t } = useTranslation();
	const { sidebarData } = useSidebarData();
	const hasCarFleet = (sidebarData?.applications?.carFleets?.length ?? 0) > 0;

	return (
		<>
			{company.tenants.map((tenant) => {
				const pivot = company.pivotValues[tenant.id];

				return (
					<ViewPageSectionListItemWrapper key={tenant.id}>
						<div>
							<strong>{tenant.name}</strong>
						</div>
						<div>
							{t("Event priority")}: {pivot?.eventPriority ?? "—"}
						</div>
						{hasCarFleet && (
							<div>
								{t("Car fleet status")}: {pivot?.carFleetStatus ? t(pivot.carFleetStatus) : "—"}
							</div>
						)}
					</ViewPageSectionListItemWrapper>
				);
			})}
		</>
	);
};
